<template>
  <header class="header" :class="{ 'is-Active': advancedSearchVisible }">
    <div class="header__Search">
      <form @submit.prevent="searchByQuery" class="search" @click="advancedSearchVisible = true">
        <div class="header__QuerySearch">
          <input
            class="search__Text--ID"
            type="search"
            v-if="$route.path.includes('clauses')"
            :placeholder="$store.getters.getStringTranslation('resourceClauseID')"
            :value="value.clause_id"
            @input="handleInputForClauseID"
          />
          <input
            class="search__Text"
            type="search"
            :placeholder="$store.getters.getStringTranslation('resourceName')"
            :value="value.search_query"
            @input="handleInput"
          />
        </div>

        <search-tag
          class="header__TagSearch"
          direction="top"
          :multiple="true"
          :lang="lang"
          :tags="tagOptions"
          @input="handleTagInput"
          placeholder="Filter resources by tags"
          :showLabel="false"
        />
      </form>
    </div>
  </header>
</template>

<script>
import debounce from 'tiny-debounce'
import SearchTag from '@/components/editor/blocks/SearchTag.vue'

export default {
  name: 'PopHeader',
  props: {
    value: {
      type: Object,
      default: () => ({
        search_query: '',
        tags: '',
      }),
    },
    lang: {
      type: String,
      default: 'en',
    },
  },
  components: {
    SearchTag,
  },
  data() {
    return {
      tagOptions: [],
      advancedSearchVisible: false,
    }
  },
  computed: {
    search: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    searchByQueryDebounced: debounce(function (value) {
      this.search = value
    }, 800),
    handleTagInput(value) {
      this.searchByQueryDebounced({ ...this.search, offset: 0, tags: value })
    },
    handleInput({ target }) {
      this.searchByQueryDebounced({ ...this.search, offset: 0, search_query: target.value })
    },
    handleInputForClauseID({ target }) {
      this.searchByQueryDebounced({ ...this.search, offset: 0, clause_id: target.value || null })
    },
  },
}
</script>
